import Api from "../../api";

import { Reservation, Event, EventShift } from "./models.jsx";

const eventsUrl = "events";
const shiftsUrl = "shifts";
const requestsUrl = "requests";

class EventApi extends Api {

	getPage(startItem, endItem, startDate, endDate, keyword, sort, callback) {

	    var url = this.baseUrl + eventsUrl;
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { startDate: startDate, endDate: endDate, keyword: keyword, sort: sort }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Event(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	get(eventId, callback) {

	    var url = this.baseUrl + eventsUrl + "/" + eventId;
	    this.client.get(url).then((response) => {
	    	callback({ 
	    		result: new Event(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	update(eventId, event, callback) {
		var url = this.baseUrl + eventsUrl + "/" + eventId;
	    this.client.put(url, event).then((response) => {
	    	callback({ 
	    		result: new Event(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

}


class ShiftsApi extends Api {

	getPage(startItem, endItem, eventId, startDate, endDate, sort, callback) {

	    var url = `${this.baseUrl}${eventsUrl}/${eventId}/${shiftsUrl}`;

	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { startDate: startDate, endDate: endDate, sort: sort }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new EventShift(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	get(eventId, shiftId, callback) {

	    var url = `${this.baseUrl}${eventsUrl}/${eventId}/${shiftsUrl}/${shiftId}`;

	    this.client.get(url).then((response) => {
	    	callback({ 
	    		result: new EventShift(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	create(shift, callback) {

		var url = `${this.baseUrl}${eventsUrl}/${shift.eventId}/${shiftsUrl}`;

	    this.client.post(url,shift).then((response) => {
	    	callback({ 
	    		result: new EventShift(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	update(shift, callback) {

		var url = `${this.baseUrl}${eventsUrl}/${shift.eventId}/${shiftsUrl}/${shift.id}`;

	    this.client.put(url,shift).then((response) => {
	    	callback({ 
	    		result: new EventShift(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	delete(eventId, shiftId, callback) {

		var url = `${this.baseUrl}${eventsUrl}/${eventId}/${shiftsUrl}/${shiftId}`;

	    this.client.delete(url).then((response) => {
	    	callback({ 
	    		result: response.data, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

}

class ReservationsApi extends Api {

	getPage(startItem, endItem, userId, states, shiftId, sort, callback) {

	    var url = `${this.baseUrl}${requestsUrl}`;

	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { userId: userId, states: states, shiftId: shiftId, sort: sort }
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Reservation(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

}

class ReservationsServiceApi{

	constructor(baseUrl) {
		this.events = new EventApi(baseUrl);
		this.shifts = new ShiftsApi(baseUrl);
		this.reservations = new ReservationsApi(baseUrl)
	}

}

export default ReservationsServiceApi;